module.exports = __webpack_public_path__ + "img/styleguide.98efd029.webp";